import React from 'react';
import {Platform, ScrollView, View} from 'react-native';

import {ValidationResiliation} from '../../../../../common/utils/validationAssuranceVoyage';
import {useFormResiliation} from '../../../../../hooks/AssuranceVoyage/useFormResiliation';
import SubmitButtons from '../../../../components/Button/SecondaryButton';
import {InputField} from '../../../../components/Inputs/InputField';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Form = (props: any) => {
  const {data, listAgence, onCancelForm, onSubmitForm} = props;

  const {
    handleChange,
    handleSubmit,
    isDisable,
    handleCancel,
    values,
    errors,
    showErrors,
    dto,
  } = useFormResiliation(
    data,
    ValidationResiliation,
    onCancelForm,
    handleSave,
    listAgence,
  );

  function handleSave() {
    onSubmitForm(dto.data);
  }

  return (
    <View style={{paddingTop: 10, flex: 1}}>
      <ScrollView
        style={[
          {paddingHorizontal: 20},
          Platform.OS === 'web' ? {} : {height: 150},
        ]}>
        <InputField
          label={'Votre message'}
          required
          type="textArea"
          name="message"
          value={values.message}
          onChange={handleChange}
          error={errors.message}
          showError={showErrors.message}
          maxLength={150}
        />
        <View style={{height: 120}} />
      </ScrollView>
      {Platform.OS === 'web' ? <View style={{height: 120}} /> : null}

      <View
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
        }}>
        <SubmitButtons
          style={{marginTop: 0, paddingTop: 10, paddingHorizontal: 20}}
          isDisable={isDisable()}
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle={'Valider'}
        />
      </View>
    </View>
  );
};
